var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotRegistered(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232,492c0-11-9-20-20-20h-92c-44.1,0-80-35.9-80-80V120c0-44.1,35.9-80,80-80H304c44.1,0,80,35.9,80,80c0,11,9,20,20,20 s20-9,20-20C424,53.8,370.2,0,304,0H120C53.8,0,0,53.8,0,120v272c0,66.2,53.8,120,120,120h92C223,512,232,503,232,492z M265,227 c0-11-9-20-20-20H137c-11,0-20,9-20,20s9,20,20,20h108C256,247,265,238,265,227z M305,150c0-11-9-20-20-20H137c-11,0-20,9-20,20 s9,20,20,20h148C296,170,305,161,305,150z M265,380c0-11-9-20-20-20H137c-11,0-20,9-20,20s9,20,20,20h108C256,400,265,391,265,380z  M265,303c0-11-9-20-20-20H137c-11,0-20,9-20,20s9,20,20,20h108C256,323,265,314,265,303z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M422.6,400l85.3-85.3c5.5-5.5,5.5-14.5,0-20.1c-5.5-5.5-14.5-5.5-20.1,0l-85.3,85.3l-85.3-85.3c-5.5-5.5-14.5-5.5-20.1,0 c-5.5,5.5-5.5,14.5,0,20.1l85.3,85.3l-85.3,85.3c-5.5,5.5-5.5,14.5,0,20.1c2.8,2.8,6.4,4.2,10,4.2c3.6,0,7.3-1.4,10-4.2l85.3-85.3 l85.3,85.3c2.8,2.8,6.4,4.2,10,4.2s7.3-1.4,10-4.2c5.5-5.5,5.5-14.5,0-20.1L422.6,400z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotRegistered);
export default __webpack_public_path__ + "static/media/not-registered.1b8ccdb1a7a1b796dace133258f69759.svg";
export { ForwardRef as ReactComponent };